import React from "react";
import "./Loading.css";
export const Loading = () => {
  return (
    <div className="loading">
      <img src="/img/loading.gif" alt="loading"></img>
    </div>
  );
};
